export const selectGrowthPlan = (state) => state.growthPlan;
